import { render, staticRenderFns } from "./CustomerEditView.vue?vue&type=template&id=3535753c"
import script from "./CustomerEditView.vue?vue&type=script&lang=js"
export * from "./CustomerEditView.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditView.vue?vue&type=style&index=0&id=3535753c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports